"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTrim = exports.useFieldError = exports.extractRegister = exports.extractRHF = void 0;
var R = __importStar(require("../../utils/ramda"));
var react_1 = require("react");
var CJFormContext_1 = require("./CJFormContext");
var useDidMount_1 = require("../../hooks/useDidMount");
var formReturnPropNames = ["watch", "getValues", "getFieldState", "setError", "clearErrors", "setValue", "trigger", "formState", "resetField", "reset", "handleSubmit", "unregister", "control", "register", "setFocus"];
var extractRHF = function (props) {
  var restProps = R.omit(formReturnPropNames, props);
  var formProps = R.pick(formReturnPropNames, props);
  return [restProps, formProps];
};
exports.extractRHF = extractRHF;
var registerPropNames = ["required", "min", "max", "maxLength", "minLength", "validate", "value", "setValueAs", "shouldUnregister", "onChange", "onBlur", "disabled", "deps", "pattern"];
var extractRegister = function (props) {
  var formProps = R.mergeRight({
    shouldUnregister: true
  }, R.pick(registerPropNames, props));
  var restProps = R.omit(registerPropNames, props);
  return [restProps, formProps];
};
exports.extractRegister = extractRegister;
var useFieldError = function (fieldName) {
  var _a = (0, react_1.useContext)(CJFormContext_1.CJFormContext),
    formState = _a.formState,
    requiredErrorText = _a.requiredErrorText;
  var error = formState.errors[fieldName];
  var message = (0, react_1.useMemo)(function () {
    if (error === null || error === void 0 ? void 0 : error.message) return error.message;
    if ((error === null || error === void 0 ? void 0 : error.type) === "required") return requiredErrorText;
    return error === null || error === void 0 ? void 0 : error.type;
  }, [error, fieldName, requiredErrorText]);
  return message;
};
exports.useFieldError = useFieldError;
var useTrim = function (field, defaultValues, autoTrim) {
  var _a, _b, _c;
  if (defaultValues === void 0) {
    defaultValues = {};
  }
  if (autoTrim === void 0) {
    autoTrim = true;
  }
  var defaultValue = (_a = R.prop(field.name, defaultValues)) !== null && _a !== void 0 ? _a : "";
  var _d = __read((0, react_1.useState)((_b = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.trim()) !== null && _b !== void 0 ? _b : ""), 2),
    _rawValue = _d[0],
    setRawValue = _d[1];
  var rawValue = _rawValue !== null && _rawValue !== void 0 ? _rawValue : "";
  var fieldValue = (_c = field.value) !== null && _c !== void 0 ? _c : "";
  var didMount = (0, useDidMount_1.useDidMount)();
  var setValue = (0, react_1.useContext)(CJFormContext_1.CJFormContext).setValue;
  (0, react_1.useEffect)(function () {
    if (autoTrim) {
      var trimmedValue = rawValue.trim();
      /* this keeps a blank field from starting out in
       an error state if form mode is "onChanged" */
      if (!didMount) {
        setValue(field.name, trimmedValue);
      } else {
        field.onChange(trimmedValue);
      }
    }
  }, [rawValue]);
  (0, react_1.useEffect)(function () {
    if (autoTrim && rawValue.trim() !== fieldValue) {
      setRawValue(fieldValue);
    }
  }, [field.value]);
  (0, react_1.useEffect)(function () {
    if (!autoTrim) {
      setValue(field.name, fieldValue);
    }
  }, []);
  var value = autoTrim ? rawValue : field.value;
  var onChange = autoTrim ? function (e) {
    return setRawValue(e.currentTarget.value);
  } : function (e) {
    return field.onChange(e.currentTarget.value);
  };
  return {
    value: value,
    onChange: onChange
  };
};
exports.useTrim = useTrim;